import { render, staticRenderFns } from "./MsCheckbox.vue?vue&type=template&id=0aa4e2b2&scoped=true"
import script from "./MsCheckbox.vue?vue&type=script&lang=js"
export * from "./MsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MsCheckbox.vue?vue&type=style&index=0&id=0aa4e2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4e2b2",
  null
  
)

export default component.exports